import {Router, Routes, Route, Outlet, Link } from 'react-router-dom'

import Uganda from './uganda';
import Uganda_s1_subjects from './uganda_s1_subjects';
import TopNavbar from '../../components/TopNavbar';
import International_countries from '../international_countries';

const Uganda_s1 = ( ) => {
 
  return (
    <>
  <TopNavbar />
   <Uganda />
   <International_countries />
  <Uganda_s1_subjects />  
  
     <Outlet />
   

</>
  );
}

export default Uganda_s1;


